import { useCallback } from "react";

import { apiUrls } from "config";
import { useCompute } from "api";

import { useFetchDataFile } from "modules/data-files/api";
import { useCreateProject } from "modules/projects/api";

import * as flowConfig from "flows/sales-effectiveness/config";

import {
  useGetInputFile,
  useGetCreateSpec,
  useGetAugmentSpec,
  useCreateStatus,
  useCreateError,
} from "./store";

export const useGetCreate = () => {
  const createProject = useCreateProject();
  const compute = useCompute(apiUrls.createProjectWithData, false);

  const inputData = useGetInputFile();
  const { data: inputFileDetails } = useFetchDataFile(inputData);

  const createSpec = useGetCreateSpec();
  const augmentSpec = useGetAugmentSpec();

  const [, setStatus] = useCreateStatus();
  const [, setError] = useCreateError();

  return useCallback(async () => {
    if (!createSpec) {
      setError("MUST select data, and set outcome");
      return;
    }
    if (
      (createSpec.meta_data[flowConfig.SUCCESS_DEFINITION_KEY] || []).length ===
      0
    ) {
      setError("MUST select data, and set success definitions!");
      return;
    }
    const successColName = augmentSpec.create_spec.new_columns[0].name;
    if ((inputFileDetails?.columns || []).includes(successColName)) {
      augmentSpec.create_spec.new_columns[0].name = `success (auto-created: ${Math.random()
        .toString(36)
        .slice(2, 5)})`;
    }
    setStatus("in-progress");
    setError(null);

    createSpec.meta_data[flowConfig.SUCCESS_COLUMN_KEY] =
      augmentSpec.create_spec.new_columns[0].name;

    const resp = await createProject(createSpec);
    if (resp.success) {
      if (augmentSpec) {
        try {
          await compute({
            data: augmentSpec,
            computeUrl: `${apiUrls.projects}/${resp.project.id}/create-and-add-data-file`,
          });
        } catch (e) {
          setError(e);
        }
      }
    } else if (resp.success === false) {
      setError(resp.error);
    }
    setStatus("completed");
    return resp;
  }, [
    inputData,
    inputFileDetails,
    createSpec,
    augmentSpec,
    createProject,
    compute,
    setStatus,
    setError,
  ]);
};
